module.exports = __webpack_public_path__ + "static/MEDICI_default-d65fafb2e6fb50d51b99e231c92e2a29.jpg";